import React from 'react';
import type { Photo } from 'app/types/commonTypes.type';
import { buildResponsiveImageAttrs } from 'app/shared/utils/fedPhotos';
import * as styles from './mediaCenter.styles';

const CubeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

type TourPreviewCardProps = {
  photo?: Photo;
  previewPhoto?: Photo;
  onClick: () => void;
  label: string;
};

export const TourPreviewCard = ({ photo, previewPhoto, onClick, label }: TourPreviewCardProps) => {
  const displayPhoto = photo || previewPhoto;
  const previewUrl = displayPhoto?.url;
  const imageAttrs = previewUrl ? buildResponsiveImageAttrs(previewUrl, 768, [384, 768, 1152]) : null;

  return (
    <button className={styles.tourButton} onClick={onClick} aria-label={label}>
      <div className={styles.tourPreview}>
        {imageAttrs ? (
          <img
            src={imageAttrs.src}
            srcSet={imageAttrs.srcSet}
            sizes="100vw"
            alt={`${label} preview`}
            className={styles.tourPreviewImageBlurred}
          />
        ) : previewUrl ? (
          <img src={previewUrl} alt={`${label} preview`} className={styles.tourPreviewImageBlurred} />
        ) : null}
        <div className={styles.tourOverlay}>
          <div className={styles.tourIconCircle}>
            <CubeIcon />
          </div>
          <span className={styles.tourLabel}>{label}</span>
        </div>
      </div>
    </button>
  );
};
